<template>
	<div :id="chartsId" style="height:100%;" :style="'width:'+ (tableWidth) +'px'" v-if="reChart"></div>
</template>

<script>
	export default {
		name: 'timeChart',
		data() {
			return {
				myChart: '',
				isCtrl: false,
				reChart: true,
				screenWidth: document.body.clientWidth,
				//0 信号未定义 1异常停止 2停止 3运转 4掉线
				types: [{
						name: this.$store.getters.getColor['0'].description,
						color: this.$store.getters.getColor['0'].color
					},
					{
						name: this.$store.getters.getColor['1'].description,
						color: this.$store.getters.getColor['1'].color
					},
					{
						name: this.$store.getters.getColor['2'].description,
						color: this.$store.getters.getColor['2'].color
					},
					{
						name: this.$store.getters.getColor['3'].description,
						color: this.$store.getters.getColor['3'].color
					}
				]
			}
		},
		props: ["chartsId", "dataCode", "dataName", "data", "beginTime", "endTime", "tableWidth"],
		computed: {
			dataChange() {
				const {
					data,
					beginTime,
					endTime,
					tableWidth
				} = this;
				return {
					data,
					beginTime,
					endTime,
					tableWidth
				};
			}
		},
		watch: {
			dataChange: {
				handler(newValue, oldValue) {
					var $this = this;
					if (newValue.data != undefined) {
						let data = [];
						newValue.data.forEach(function(item, index1) {
							let type = item.lastValue == null ? 0 : Number(item.lastValue);
							if (type < 0 || type > 4) {
								type = 0;
							}
							let typeItem = $this.types[type];
							let ssTime = item.startTime
							let eeTime = item.endTime
							if (ssTime < $this.beginTime) {
								ssTime = $this.beginTime
							}
							if (eeTime > $this.endTime) {
								eeTime = $this.endTime
							}

							if (type != 4) {
								data.push({
									name: typeItem.name,
									value: [
										0,
										ssTime,
										eeTime
									],
									itemStyle: {
										normal: {
											color: typeItem.color
										}
									}
								});
							} else {
								data.push({
									name: null,
									value: [
										0,
										ssTime,
										eeTime
									],
									itemStyle: {
										normal: {
											color: 'rgba(0,0,0,0)'
										}
									}
								});
							}

						})
						if (data.length > 0) {
							let time1 = data[data.length - 1].value[1]
							let time2 = data[data.length - 1].value[2]
							if (time2 < $this.endTime) {
								data.push({
									name: null,
									value: [
										0,
										time2,
										$this.endTime
									],
									itemStyle: {
										normal: {
											color: 'rgba(0,0,0,0)'
										}
									}
								});
							}
							if (time1> $this.beginTime) {
								data.unshift({
									name: null,
									value: [
										0,
										$this.beginTime,
										time1
									],
									itemStyle: {
										normal: {
											color: 'rgba(0,0,0,0)'
										}
									}
								});
							}
						} else {
							data.push({
								name: null,
								value: [
									0,
									newValue.beginTime,
									newValue.endTime
								],
								itemStyle: {
									normal: {
										color: 'rgba(0,0,0,0)'
									}
								}
							});
						}
						this.myChart.setOption({
							series: [{
								data: data
							}]
						});
					} else {
						var $this = this;
						this.myChart.setOption({
							series: [{
								data: [{
									name: null,
									value: [
										0,
										newValue.beginTime,
										newValue.endTime
									],
									itemStyle: {
										normal: {
											color: 'rgba(0,0,0,0)'
										}
									}
								}]
							}]
						});
					}
				},
				// deep: true
			},
		},
		methods: {
			renderItem(params, api) {
				let categoryIndex = api.value(0);
				let start = api.coord([api.value(1), categoryIndex]);
				let end = api.coord([api.value(2), categoryIndex]);
				let height = api.size([0, 1])[1] * 0.8;
				let rectShape = this.$echarts.graphic.clipRectByRect({
					x: start[0],
					y: start[1] - height / 2,
					width: end[0] - start[0],
					height: height
				}, {
					x: params.coordSys.x,
					y: params.coordSys.y,
					width: params.coordSys.width,
					height: params.coordSys.height
				});

				return rectShape && {
					type: 'rect',
					shape: rectShape,
					style: api.style()
				};
			},

			getTime(time) {
				return new Date(time).getTime();
			},
			echarts() {
				// 基于准备好的dom，初始化echarts实例

				this.myChart = this.$echarts.init(document.getElementById(this.chartsId))
				// 绘制图表
				let data = [];
				let dataCount = 10;
				let categories = [''];
				// Generate mock data
				var $this = this;
				if ($this.data != undefined) {
					categories.forEach(function(category, index) {
						$this.data.forEach(function(item, index1) {
							let type = item.lastValue == null ? 0 : Number(item.lastValue);
							if (type < 0 || type > 4) {
								type = 0;
							}
							let typeItem = $this.types[type];

							let ssTime = item.startTime
							let eeTime = item.endTime
							if (ssTime < $this.beginTime) {
								ssTime = $this.beginTime
							}
							if (eeTime > $this.endTime) {
								eeTime = $this.endTime
							}
							if (type != 4) {
								data.push({
									name: typeItem.name,
									value: [
										0,
										ssTime,
										eeTime
									],
									itemStyle: {
										normal: {
											color: typeItem.color
										}
									}
								});
							} else {
								data.push({
									name: null,
									value: [
										0,
										ssTime,
										eeTime
									],
									itemStyle: {
										normal: {
											color: 'rgba(0,0,0,0)'
										}
									}
								});
							}
						})
						if (data.length > 0) {
							let time1 = data[data.length - 1].value[1]
							let time2 = data[data.length - 1].value[2]
							if (time2 < $this.endTime) {
								data.push({
									name: null,
									value: [
										0,
										time2,
										$this.endTime
									],
									itemStyle: {
										normal: {
											color: 'rgba(0,0,0,0)'
										}
									}
								});
							}
							if (time1> $this.beginTime) {
								data.unshift({
									name: null,
									value: [
										0,
										$this.beginTime,
										time1
									],
									itemStyle: {
										normal: {
											color: 'rgba(0,0,0,0)'
										}
									}
								});
							}
						} else {
							data.push({
								name: null,
								value: [
									0,
									$this.beginTime,
									$this.endTime
								],
								itemStyle: {
									normal: {
										color: 'rgba(0,0,0,0)'
									}
								}
							});
						}
					});
				} else {
					data.push({
						name: null,
						value: [
							0,
							$this.beginTime,
							$this.endTime
						],
						itemStyle: {
							normal: {
								color: 'rgba(0,0,0,0)'
							}
						}
					});
				}
				let option = {
					tooltip: {
						formatter: function(params) {
							if (params.name != null && params.name != '') {
								let sTime = $this.getTime(params.value[1]);
								let eTime = $this.getTime(params.value[2]);
								return $this.dataCode + ' ' + $this.dataName + "<br>" + params.marker + params.name + ': ' + ((eTime - sTime) /
									1000 /
									60).toFixed(2) + '分钟（' + params.value[1] + '~' + params.value[2] + ")";
							}

						}
					},
					// backgroundColor: '#eef8ff',
					dataZoom: [{
						type: 'slider',
						filterMode: 'weakFilter',
						showDataShadow: false,
						left: 40,
						right: 40,
						height: 10,
						bottom: 25,
						borderColor: 'transparent',
						backgroundColor: '#eef8ff',
						handleSize: 20,
						handleIcon: 'M10.7,11.9H9.3c-4.9,0.3-8.8,4.4-8.8,9.4c0,5,3.9,9.1,8.8,9.4h1.3c4.9-0.3,8.8-4.4,8.8-9.4C19.5,16.3,15.6,12.2,10.7,11.9z M13.3,24.4H6.7v-1.2h6.6z M13.3,22H6.7v-1.2h6.6z M13.3,19.6H6.7v-1.2h6.6z', // jshint ignore:line
						handleStyle: {
							shadowBlur: 6,
							shadowOffsetX: 1,
							shadowOffsetY: 2,
							shadowColor: '#aaa'
						},
						labelFormatter: ''
					}, {
						type: 'inside',
						filterMode: 'weakFilter'
					}],
					grid: {
						height: 80,
						left: 40,
						right: 40,
						bottom: 25,
					},
					xAxis: {
						type: "time",
						axisLabel: {
							formatter: function(val) {
								let date = new Date(val)
								let m = date.getMonth() + 1;
								let d = date.getDate();
								let h = date.getHours();
								let min = date.getMinutes();
								if (m < 10) {
									m = "0" + m;
								}
								if (d < 10) {
									d = "0" + d;
								}
								if (h < 10) {
									h = "0" + h;
								}
								if (min < 10) {
									min = "0" + min;
								}
								return m + '-' + d + ' ' + h + ':' + min;
							}
						}
					},
					yAxis: {
						data: categories
					},
					series: [{
						type: 'custom',
						renderItem: this.renderItem,
						itemStyle: {
							opacity: 0.8
						},
						encode: {
							x: [1, 2],
							y: 0
						},
						data: data
					}]
				};
				this.myChart.setOption(option);
			},
		},
		mounted() {
			this.echarts();

			//window.addEventListener('resize', this.resizeChart, true)
		},
		created() {

		}
	}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/list/chart/timeChart.vue